
(function(){
  var box = document.querySelector('[data-buybox]');
  if(!box) return;
  var fmt = box.getAttribute('data-money-format') || '${{amount}}';
  function money(cents){
    cents = Math.round(cents);
    var a = (cents/100).toFixed(2), n0 = Math.round(cents/100).toString();
    var withComma = a.replace('.', ',');
    function thou(s, sep){ var p=s.split('.'); p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep); return p.join('.'); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
      if(k==='amount_no_decimals') return thou(n0, ',');
      if(k==='amount_with_comma_separator') return thou(a, '.').replace(/\.(\d{2})$/, ',$1');
      if(k==='amount_no_decimals_with_comma_separator') return thou(n0, '.');
      if(k==='amount_with_apostrophe_separator') return thou(a, "'");
      return thou(a, ',');
    });
  }
  function cadence(name){
    var m = /(\d+)\s*[- ]?\s*(day|week|month|year)/i.exec(name||'');
    if(!m) return null;
    var n = parseInt(m[1],10), u = m[2].toLowerCase();
    return n === 1 ? ('every ' + u) : ('every ' + n + ' ' + u + 's');
  }
  var hasPlans = box.getAttribute('data-has-plans') === 'true';
  var subscribing = hasPlans;
  var tiers = [].slice.call(box.querySelectorAll('[data-tier]'));
  var form = box.querySelector('form');
  var idIn = form.querySelector('input[name="id"]');
  var qtyIn = box.querySelector('[data-qty]');
  var planIn = form.querySelector('input[name="selling_plan"]');
  var atc = box.querySelector('[data-atc]');
  var atcLabel = box.querySelector('[data-atc-label]');
  var renew = box.querySelector('[data-renew]');
  var toggle = box.querySelector('[data-onetime]');
  var subBanner = box.querySelector('[data-sub-banner]');
  var sticky = document.querySelector('[data-buy-sticky]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var T = JSON.parse(box.getAttribute('data-text') || '{}');
  function cur(){ return tiers.filter(function(t){ return t.classList.contains('on'); })[0] || tiers[0]; }
  function qty(){ var q = parseInt(qtyIn.value,10); return isNaN(q)||q<1 ? 1 : Math.min(q, 99); }
  function render(){
    tiers.forEach(function(t){
      var p = +t.dataset.price, sp = +t.dataset.subPrice, count = +t.dataset.count || 1;
      var usePlan = subscribing && t.dataset.plan;
      var now = usePlan ? sp : p;
      t.querySelector('[data-now]').textContent = money(now);
      var was = t.querySelector('[data-was]'), save = t.querySelector('[data-save]');
      if(usePlan && sp < p){
        was.textContent = money(p); was.hidden = false;
        save.textContent = (T.save || 'Save') + ' ' + Math.round((1 - sp/p)*100) + '%'; save.hidden = false;
      } else { was.hidden = true; save.hidden = true; }
      t.querySelector('[data-per]').textContent = money(now / count) + ' ' + (T.per || 'per bottle');
    });
    var t = cur();
    var usePlan = subscribing && t.dataset.plan;
    idIn.value = t.dataset.variant;
    planIn.value = usePlan ? t.dataset.plan : '';
    planIn.disabled = !usePlan;
    var total = (usePlan ? +t.dataset.subPrice : +t.dataset.price) * qty();
    var avail = t.dataset.available === 'true';
    atc.disabled = !avail;
    atcLabel.textContent = avail ? ((T.atc || 'Get Colapaw') + ' — ' + money(total)) : (T.soldout || 'Sold out');
    if(stickyPrice) stickyPrice.textContent = money(total);
    if(renew){
      if(usePlan){
        var c = cadence(t.dataset.planName);
        renew.textContent = (c ? (T.renews || 'Renews') + ' ' + c + ' ' + (T.at || 'at') + ' ' + money(total) + '. ' : '') + (T.cancel || 'Pause or cancel anytime.');
        renew.hidden = false;
      } else { renew.hidden = true; }
    }
    if(subBanner) subBanner.hidden = !subscribing;
    if(toggle){
      toggle.textContent = subscribing
        ? (T.buyonce || 'Or buy once for') + ' ' + money(+t.dataset.price * qty()) + ' →'
        : (T.backsub || '← Switch back to subscribe & save');
    }
  }
  tiers.forEach(function(t){
    t.addEventListener('click', function(e){
      if(t.dataset.available !== 'true') return;
      tiers.forEach(function(x){ x.classList.remove('on'); x.querySelector('input').checked = false; });
      t.classList.add('on'); t.querySelector('input').checked = true; render();
    });
  });
  if(toggle){ toggle.addEventListener('click', function(e){ e.preventDefault(); subscribing = !subscribing; render(); }); }
  box.querySelectorAll('[data-step]').forEach(function(b){
    b.addEventListener('click', function(){ qtyIn.value = Math.max(1, Math.min(99, qty() + (+b.dataset.step))); render(); });
  });
  qtyIn.addEventListener('input', render);
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var t = cur(); if(t.dataset.available !== 'true') return;
    atc.disabled = true;
    var body = { id: Number(t.dataset.variant), quantity: qty() };
    if(subscribing && t.dataset.plan) body.selling_plan = Number(t.dataset.plan);
    fetch('/cart/clear.js', { method:'POST', headers:{'Content-Type':'application/json'} })
      .then(function(){ return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(body) }); })
      .then(function(r){ if(!r.ok) throw 0; window.location.href = '/checkout' + window.location.search; })
      .catch(function(){ atc.disabled = false; form.submit(); });
  });
  if(sticky && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(en){ sticky.classList.toggle('show', !en.isIntersecting && window.innerWidth < 900); });
    }, {threshold: 0});
    io.observe(form);
  }
  render();
})();
